(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2038],{

/***/ 7722:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/enterprise-applications",
      function () {
        return __webpack_require__(8553);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuccessStoryEmbed; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2684);





var allCaseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_3__.filter(function(item) {
    var ref;
    return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
}).map(function(item) {
    return {
        title: item.meta.title || "",
        slug: item.meta.slug || "",
        img: item.meta.img || null,
        industry_descriptor: item.meta.industry_descriptor || null,
        outcome_metric: item.meta.outcome_metric || null,
        refer: Array.isArray(item.meta.refer) ? item.meta.refer : [],
        date: item.meta.date || ""
    };
});
function SuccessStoryEmbed(param) {
    var referTag = param.referTag, _maxItems = param.maxItems, maxItems = _maxItems === void 0 ? 3 : _maxItems, _heading = param.heading, heading = _heading === void 0 ? "Work we've shipped for clients like you" : _heading;
    var stories = referTag ? allCaseStudies.filter(function(s) {
        return s.refer.includes(referTag);
    }) : [];
    if (stories.length === 0) {
        stories = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(allCaseStudies).sort(function(a, b) {
            return b.date > a.date ? 1 : -1;
        });
    }
    var visible = stories.slice(0, maxItems);
    if (!visible.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-12 px-6 md:px-[60px] bg-gray-50 text-left",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-6xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-left",
                    children: heading
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-8",
                    children: visible.map(function(story) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/blog/".concat(story.slug),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "group bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-blue-400 hover:shadow-md transition-all flex flex-col",
                                children: [
                                    story.img && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative w-full h-44 bg-gray-100",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            src: story.img,
                                            alt: story.title,
                                            fill: true,
                                            className: "object-cover",
                                            sizes: "(max-width: 768px) 100vw, 400px",
                                            placeholder: "blur",
                                            blurDataURL: "/blogImages/hero/placeholder.webp"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "p-5 flex flex-col flex-1",
                                        children: [
                                            story.industry_descriptor && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-blue-500 text-xs uppercase tracking-wide font-medium mb-2",
                                                children: story.industry_descriptor
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors leading-snug mb-3 flex-1",
                                                children: story.title
                                            }),
                                            story.outcome_metric && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-auto pt-3 border-t border-gray-100",
                                                children: story.outcome_metric
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, story.slug);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/success-stories",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "inline-block border border-gray-300 hover:border-blue-500 text-gray-700 hover:text-blue-600 font-semibold px-7 py-3 rounded-lg transition-colors text-sm",
                            children: "See all success stories →"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 8553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ enterpriseApplications; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1180);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2684);
/* harmony import */ var _components_services_Service2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3230);
/* harmony import */ var _components_trust_SuccessStoryEmbed__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2100);
/* harmony import */ var _components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2616);
/* harmony import */ var _components_services_ServiceEngagementLinks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5733);
/* harmony import */ var _components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4837);








var Capabilities2 = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5791), __webpack_require__.e(8388), __webpack_require__.e(5290), __webpack_require__.e(7517), __webpack_require__.e(7113)]).then(__webpack_require__.bind(__webpack_require__, 7517));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7517)
            ];
        }
    },
    ssr: false
});




var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 2941).then(__webpack_require__.bind(__webpack_require__, 3193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3193)
            ];
        }
    },
    ssr: false
});
enterpriseApplications.title = "Enterprise Application Modernisation & ERP Consulting | ITMTB";
enterpriseApplications.desc = "ITMTB modernises legacy enterprise applications and ERP systems — making them integration-ready for AI agents and scalable for growth. SAP, Microsoft Dynamics 365, Oracle, Salesforce.";
enterpriseApplications.header_img = "https://www.itmtb.com/services/capability/automate.webp";
enterpriseApplications.keywords = "enterprise application modernisation India, ERP consulting India, legacy system modernisation AI, SAP Dynamics 365 consulting India, agent-ready enterprise systems, custom enterprise software development India";
var faqItems = [
    {
        q: "How do I make my legacy ERP ready for AI agents?",
        a: "Making a legacy ERP agent-ready is primarily an integration problem, not a replacement problem. AI agents need to be able to query and write to your ERP in real time — which requires either a well-documented API layer or a purpose-built integration service. Most legacy ERPs (SAP, older Dynamics versions, Tally) don't expose clean APIs by default; some require middleware (MuleSoft, Azure Integration Services, custom API gateways) to make their data accessible to external systems. The practical steps: (1) audit what your ERP exposes today — which entities, which operations, with what latency; (2) build an API layer that translates your ERP's data model into a clean, versioned interface your agents can call; (3) add event streaming for real-time data (Kafka, Azure Event Hub, or AWS EventBridge) so agents can react to ERP state changes rather than polling. We scope this integration architecture during the discovery sprint and implement it as a defined, testable layer — so your AI investment isn't blocked by data access."
    },
    {
        q: "Which ERP is right for an Indian mid-market enterprise — SAP, Microsoft Dynamics 365, or Oracle?",
        a: "Each has a different fit depending on company size, industry, and existing technology footprint. SAP Business One or SAP S/4HANA Cloud is the right call when you need deep manufacturing or supply chain modules, are planning international expansion requiring multi-currency/multi-entity consolidation, or are in an industry where SAP is the de facto standard (automotive, chemicals, pharma). Microsoft Dynamics 365 Business Central is the right call when your team already lives in Microsoft 365, you want a low-friction integration with Azure and Power Platform, or you're a services or D2C business without complex manufacturing requirements. Oracle NetSuite is the right call for growing mid-market businesses with multi-entity, multi-currency requirements — particularly strong for professional services, distribution, and software companies that need consolidated financial reporting across subsidiaries. Oracle ERP Cloud suits larger enterprises with complex procurement, finance, and project management needs. We scope platform selection during the discovery sprint and give you a direct recommendation based on your specific workload, not vendor partnerships."
    },
    {
        q: "What does enterprise application modernisation actually involve technically?",
        a: "Modernisation can mean different things depending on the current state. For a monolith being broken into microservices: the process is domain decomposition (identifying bounded contexts), strangler-fig migration (wrapping existing functionality progressively, not big-bang rewrite), API gateway introduction, and data store separation. For a legacy Java EE or .NET Framework application being moved to modern runtimes: containerisation, framework upgrade, dependency audit, and cloud deployment. For a data model that wasn't designed for AI: schema normalisation, CDC (change data capture) pipeline introduction, and API layer over the cleaned data. The right approach depends on why the system needs to be modernised — cost, scalability, AI readiness, or integration complexity. We define the target state and migration path during the discovery sprint, with a risk register that tells you what could break and how we'd handle it."
    },
    {
        q: "How long does legacy system modernisation take?",
        a: "This is highly dependent on the size and complexity of the existing system, and what 'done' means. A focused API-enablement project (adding a clean REST API over a legacy system without changing the core) takes 6–10 weeks. A full monolith-to-microservices decomposition for a mid-size system takes 6–12 months depending on team size and the number of bounded contexts. A framework migration (Python 2 to 3, .NET Framework to .NET 8, Java EE to Spring Boot) without business logic changes typically takes 4–8 weeks for a medium-sized codebase. The discovery sprint (2 weeks, fixed price) produces a precise estimate for your specific system — including a risk register for the migration and a recommendation on migration path (rewrite vs. refactor vs. wrap)."
    },
    {
        q: "What's the difference between ERP implementation and custom enterprise application development?",
        a: "An ERP implementation takes an existing platform (SAP, Microsoft Dynamics 365, Oracle) and configures it to fit your business processes — defining workflows, setting up master data, integrating with other systems, and training your team. The software already exists; the work is configuration, integration, and change management. Custom enterprise application development builds something that doesn't exist: a bespoke application for a specific business process where no off-the-shelf product fits well enough. Custom development is justified when: your process is genuinely unique and a standard ERP would require so much customisation that it becomes unmaintainable; you need a purpose-built tool that connects multiple systems in a way no packaged product supports; or you're building a competitive differentiator (a proprietary logistics platform, a custom risk engine) that you don't want to run on a vendor's infrastructure. For most operational workflows, a well-implemented ERP is faster and cheaper than custom software. We give you a direct recommendation in the discovery sprint."
    },
    {
        q: "How does ITMTB price an engagement?",
        a: "Pricing follows the engagement model. Discovery sprints are fixed-price for a fixed timebox. Build engagements are scoped after discovery — fixed-scope, time-and-materials, or outcome-linked. Managed services are billed monthly with defined SLAs. Total cost depends on scope, integration complexity, QA depth, and post-launch support — we publish a transparent breakdown for buyers evaluating their options.",
        link: "/blog/custom-software-development-cost-india",
        linkLabel: "Read the cost guide"
    },
    {
        q: "What does an engagement with ITMTB look like?",
        a: "Every engagement starts with a fixed-scope, fixed-price discovery sprint — typically 2 weeks. You leave with a written roadmap, risk register, cost estimate, and timeline before committing to a build. We then offer four engagement models: fixed-scope builds, time-and-materials, outcome-linked retainers, and managed services post-launch. If discovery doesn't justify proceeding, you can stop there — no obligation.",
        link: "/itmtb-how-we-work",
        linkLabel: "See how we work"
    }, 
];
enterpriseApplications.faq = faqItems;
var jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
        {
            "@type": "Service",
            "name": "Enterprise Application Modernisation & ERP Consulting",
            "provider": {
                "@type": "Organization",
                "name": "ITMTB",
                "url": "https://www.itmtb.com",
                "logo": "https://www.itmtb.com/logo.webp",
                "sameAs": [
                    "https://www.linkedin.com/company/itmtb-technologies/",
                    "https://x.com/ITMTBTech", 
                ]
            },
            "areaServed": {
                "@type": "Country",
                "name": "India"
            },
            "serviceType": "Enterprise Application Modernisation",
            "description": "ITMTB modernises legacy enterprise applications and ERP systems — making them integration-ready for AI agents and scalable for growth. SAP, Microsoft Dynamics 365, Oracle, Salesforce.",
            "offers": {
                "@type": "Offer",
                "priceSpecification": {
                    "@type": "PriceSpecification",
                    "description": "Fixed-price discovery sprint, then custom proposal based on scope"
                }
            }
        }, 
    ]
};
var activities = [
    "ERP implementation",
    "Legacy modernisation",
    "API enablement",
    "Agent integration layer",
    "Custom development",
    "Framework upgrades",
    "Database migration",
    "Cloud deployment",
    "Performance optimisation", 
];
var engagementPhases = [
    {
        period: "Discovery Sprint",
        items: [
            "Architecture and dependency review",
            "API exposure and integration capability audit",
            "Risk register and migration path recommendation",
            "Written cost estimate and timeline",
            "Rewrite vs. refactor vs. wrap recommendation", 
        ]
    },
    {
        period: "API & Integration Layer",
        items: [
            "Versioned API layer over legacy data stores",
            "Event streaming for real-time agent access",
            "Agent integration interface specification",
            "Security and access control architecture", 
        ]
    },
    {
        period: "Progressive Migration",
        items: [
            "Strangler-fig approach: domain-by-domain",
            "Legacy system runs through the transition",
            "Framework and runtime upgrades per domain",
            "CI/CD pipeline maintained throughout", 
        ]
    }, 
];
var comparisonRows = [
    {
        label: "Risk",
        col1: "High — entire system replaced at once",
        col2: "Medium — infrastructure changes, logic unchanged",
        col3: "Low — legacy runs until each domain is replaced"
    },
    {
        label: "Business continuity",
        col1: "Disruption during cutover",
        col2: "Minimal operational disruption",
        col3: "Continuous — no single cutover event"
    },
    {
        label: "Timeline",
        col1: "Longest — full rebuild required",
        col2: "Shortest — infrastructure only",
        col3: "Moderate — phased by domain count"
    },
    {
        label: "AI readiness result",
        col1: "Depends on new architecture decisions",
        col2: "Poor — same integration constraints remain",
        col3: "High — API layer built into migration"
    },
    {
        label: "Cost profile",
        col1: "High upfront, lower long-term maintenance",
        col2: "Low upfront, unchanged maintenance overhead",
        col3: "Moderate upfront, reduced maintenance overhead"
    },
    {
        label: "Recommended for",
        col1: "Greenfield replacement only",
        col2: "Infrastructure-constrained migrations",
        col3: "Most enterprise modernisation engagements"
    }, 
];
var modernisationPhases = [
    {
        phase: "01",
        title: "Discovery Sprint",
        duration: "2 weeks \xb7 Fixed price",
        items: [
            "Architecture review and dependency mapping",
            "API exposure and integration capability audit",
            "Risk register for chosen migration approach",
            "Cost estimate and timeline before build commitment",
            "Written recommendation: rewrite vs. refactor vs. wrap", 
        ]
    },
    {
        phase: "02",
        title: "API & Integration Architecture",
        duration: "Weeks 3–6",
        items: [
            "Versioned API layer design over legacy data stores",
            "Event streaming architecture (Kafka, Azure Event Hub, EventBridge)",
            "Agent integration interface specification",
            "Security and access control design", 
        ]
    },
    {
        phase: "03",
        title: "Progressive Migration",
        duration: "Phased delivery",
        items: [
            "Strangler-fig approach: domain-by-domain migration",
            "Legacy system runs until each domain is replaced",
            "Framework and runtime upgrades (Python 3, .NET 8, Spring Boot)",
            "CI/CD pipeline maintained through migration", 
        ]
    },
    {
        phase: "04",
        title: "Handover & Operations",
        duration: "Post-delivery",
        items: [
            "Architecture documentation and runbooks",
            "Knowledge transfer and team training",
            "4–8 week post-launch warranty period",
            "Optional transition to managed services", 
        ]
    }, 
];
var subServices = [
    {
        img: null,
        key: "Agent-Ready Enterprise Integration",
        title: "Your AI agents are only as good as the enterprise systems they can reach — we build the integration layer.",
        text: "Most legacy ERPs, CRMs, and internal applications don't expose clean APIs by default. AI agents that can't reach live operational data can't act on it. We audit what your systems expose today, build versioned API layers over legacy data stores, and add event streaming so agents can react to system state changes in real time.\n\nSystems we've integrated: SAP, Microsoft Dynamics 365, Salesforce, Tally, proprietary databases, and legacy Java EE / .NET applications."
    },
    {
        img: null,
        key: "ERP Implementation and Customisation",
        title: "The right ERP for your business, implemented correctly from the start.",
        text: "We implement and customise ERP systems for mid-market enterprises: SAP Business One and S/4HANA Cloud for complex manufacturing and supply chain; Microsoft Dynamics 365 Business Central for Microsoft-stack organisations; Oracle NetSuite for multi-entity, multi-currency businesses; Oracle ERP Cloud for large enterprise requirements.\n\nImplementation includes workflow configuration, master data setup, system integration, and handoff training — not just licence installation."
    },
    {
        img: null,
        key: "Legacy System Modernisation",
        title: "Strangler-fig migrations, not risky big-bang rewrites.",
        text: "We modernise legacy applications using a progressive approach: wrap existing functionality with a clean API, migrate functionality domain by domain, and retire the legacy system incrementally. This reduces risk compared to full rewrites and keeps your business running through the transition.\n\nMigration paths we've executed: monolith to microservices, Python 2 to 3, Java EE to Spring Boot, .NET Framework to .NET 8, on-premises to cloud-native."
    },
    {
        img: null,
        key: "Custom Enterprise Application Development",
        title: "When no off-the-shelf product fits your process well enough to be worth the customisation.",
        text: "Custom development is justified for processes that are genuinely unique: a proprietary logistics coordination platform, a custom risk engine, a bespoke workflow tool that connects systems in a way no packaged product supports. We scope whether custom development is warranted versus ERP configuration during the discovery sprint — and give you an honest recommendation.\n\nFor the cases where custom is the right call, we build production-grade systems with proper testing, monitoring, and documentation — not prototypes handed off without ops support."
    },
    {
        img: null,
        key: "Application Performance and Reliability",
        title: "Software that degrades silently is worse than software that fails loudly.",
        text: "Performance problems in enterprise applications have two root causes: architectural decisions that don't scale, and incremental degradation as data volumes and usage patterns change. We diagnose both: database query profiling, API latency analysis, memory and CPU profiling under load, and cache effectiveness review.\n\nFor cloud-hosted applications, performance is also a cost issue — slow queries that run frequently are expensive. We profile, optimise, and add monitoring so you catch regressions before your users do."
    }, 
];
function enterpriseApplications() {
    var insights = _blogs_json__WEBPACK_IMPORTED_MODULE_4__.filter(function(item) {
        var ref;
        return ![
            "case-study",
            "tech"
        ].includes(item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category);
    });
    var caseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_4__.filter(function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
    });
    var filteredInsights = insights.filter(function(item) {
        var ref, ref1;
        return item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("Enterprise Applications and Automation");
    });
    var filteredCaseStudies = caseStudies.filter(function(item) {
        var ref, ref1;
        return item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("Enterprise Applications and Automation");
    });
    if (filteredInsights.length === 1) {
        insights = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(filteredInsights).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__/* .getRandom */ .s)(insights.filter(function(item) {
            return !filteredInsights.includes(item);
        }), 1)));
    } else if (filteredInsights.length >= 2) {
        insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__/* .getRandom */ .s)(filteredInsights, 2);
    } else {
        insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__/* .getRandom */ .s)(insights, 2);
    }
    if (filteredCaseStudies.length === 1) {
        caseStudies = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(filteredCaseStudies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__/* .getRandom */ .s)(caseStudies.filter(function(item) {
            return !filteredCaseStudies.includes(item);
        }), 1)));
    } else if (filteredCaseStudies.length >= 2) {
        caseStudies = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__/* .getRandom */ .s)(filteredCaseStudies, 2);
    } else {
        caseStudies = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_11__/* .getRandom */ .s)(caseStudies, 2);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(jsonLd)
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_Service2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                heading: "Enterprise Application Modernisation & ERP Consulting",
                paragraph: 'AI agents can only act on data they can reach. For most enterprises, that means ERP, CRM, and internal applications need to be integration-ready before AI deployment can begin.<ul style="margin-top:16px;padding-left:20px;list-style:disc;display:flex;flex-direction:column;gap:8px"><li>SAP, Microsoft Dynamics 365, Oracle — implemented and customised for enterprises</li><li>Strangler-fig migrations — not big-bang rewrites</li><li>API enablement and event streaming for agent-ready systems</li><li>Fixed-price discovery sprint before any build commitment</li></ul>',
                primaryCta: null,
                heroSvg: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    viewBox: "0 0 440 400",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "w-full max-w-md opacity-70",
                    "aria-hidden": "true",
                    role: "presentation",
                    children: [
                        (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(Array(6)).map(function(_, row) {
                            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(Array(7)).map(function(_, col) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                    cx: 40 + col * 60,
                                    cy: 40 + row * 60,
                                    r: "1.5",
                                    fill: "#e2e8f0"
                                }, "".concat(row, "-").concat(col));
                            });
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "155",
                            y: "20",
                            width: "130",
                            height: "38",
                            rx: "7",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "15",
                            y: "155",
                            width: "100",
                            height: "38",
                            rx: "7",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "325",
                            y: "155",
                            width: "100",
                            height: "38",
                            rx: "7",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "55",
                            y: "305",
                            width: "110",
                            height: "38",
                            rx: "7",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "275",
                            y: "305",
                            width: "110",
                            height: "38",
                            rx: "7",
                            stroke: "#94a3b8",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "148",
                            y: "13",
                            width: "144",
                            height: "52",
                            rx: "11",
                            stroke: "#94a3b8",
                            strokeWidth: "0.8",
                            strokeOpacity: "0.35",
                            strokeDasharray: "3 3"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "268",
                            y: "298",
                            width: "124",
                            height: "52",
                            rx: "11",
                            stroke: "#94a3b8",
                            strokeWidth: "0.8",
                            strokeOpacity: "0.35",
                            strokeDasharray: "3 3"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 220 58 C 220 100 220 148 220 182",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 115 174 C 148 182 172 188 202 196",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 325 174 C 293 182 268 188 238 196",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 110 324 C 148 304 176 260 208 218",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M 330 324 C 293 304 264 260 232 218",
                            stroke: "#cbd5e1",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "200",
                            r: "26",
                            stroke: "#b45309",
                            strokeWidth: "1",
                            strokeOpacity: "0.3",
                            strokeDasharray: "5 3"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "200",
                            r: "18",
                            stroke: "#b45309",
                            strokeWidth: "2"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "200",
                            r: "7",
                            fill: "#b45309",
                            fillOpacity: "0.15",
                            stroke: "#b45309",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "220",
                            cy: "39",
                            r: "2.5",
                            fill: "#cbd5e1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "65",
                            cy: "174",
                            r: "2.5",
                            fill: "#cbd5e1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "375",
                            cy: "174",
                            r: "2.5",
                            fill: "#cbd5e1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "110",
                            cy: "324",
                            r: "2.5",
                            fill: "#cbd5e1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "330",
                            cy: "324",
                            r: "2.5",
                            fill: "#cbd5e1"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                className: "bg-white border-b border-gray-100 px-6 md:px-[60px] py-2 overflow-x-auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex gap-6 text-sm font-medium whitespace-nowrap",
                    children: [
                        {
                            label: "Who it's for",
                            href: "#who-its-for"
                        },
                        {
                            label: "Modernisation approaches",
                            href: "#comparison"
                        },
                        {
                            label: "How we modernise",
                            href: "#how-we-modernise"
                        },
                        {
                            label: "Engagement model",
                            href: "#engagement-model"
                        },
                        {
                            label: "FAQ",
                            href: "#faq"
                        }, 
                    ].map(function(param) {
                        var label = param.label, href = param.href;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: href,
                            className: "text-gray-500 hover:text-indigo-600 transition-colors py-1",
                            children: label
                        }, href);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_9__/* .CustomerSection */ .a, {
                title: "Trusted by"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-12 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-5",
                            children: "What is enterprise application modernisation?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: "Enterprise application modernisation is the process of updating legacy business systems — ERPs, CRMs, and internal platforms — so they integrate with modern tooling, expose clean data to AI agents, and scale without accumulating further technical debt."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: [
                                "The most common misconception is that modernisation means full replacement. In most cases it does not. The right approach is wrapping existing systems with a versioned API layer, migrating functionality domain by domain using a strangler-fig pattern, and retiring legacy components progressively — keeping business operations uninterrupted through the transition. Replacement also carries hidden lifecycle spend — the",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/blog/custom-software-development-cost-india",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "text-indigo-600 font-medium hover:text-indigo-800 transition-colors",
                                        children: "support, QA, and total-ownership economics"
                                    })
                                }),
                                " ",
                                "that rarely appear in the initial build estimate."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed",
                            children: "ITMTB has delivered enterprise application modernisation and ERP engagements for businesses across India, the United Kingdom, the United Arab Emirates, and Southeast Asia — covering SAP and Dynamics 365 implementations, legacy Java EE and .NET migrations, and integration layers that made decade-old systems queryable by AI agents within weeks of engagement start."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "who-its-for",
                className: "scroll-mt-24 px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-10",
                            children: "Who This Is For"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "space-y-10",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-lg font-bold text-gray-900 mb-2",
                                            children: "Enterprises whose ERP blocks AI adoption"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-gray-600 text-base leading-relaxed",
                                            children: "Your AI or automation initiative stalls because your ERP or CRM doesn't expose usable APIs. Agents can't query inventory, order status, or customer records in real time — so they operate on stale exports or can't act at all. Modernising the integration layer unblocks the AI investment without replacing the core system."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-lg font-bold text-gray-900 mb-2",
                                            children: "Companies evaluating SAP, Microsoft Dynamics 365, or Oracle"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-gray-600 text-base leading-relaxed",
                                            children: "Businesses that need to select and implement an ERP for the first time, or replace a system that no longer fits their scale. The right platform depends on your industry, technology footprint, and operational complexity — SAP for manufacturing and supply chain, Microsoft Dynamics 365 for Microsoft-integrated organisations, Oracle NetSuite for multi-entity mid-market businesses, Oracle ERP Cloud for large enterprise requirements."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-lg font-bold text-gray-900 mb-2",
                                            children: "Organisations running business-critical legacy applications"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-gray-600 text-base leading-relaxed",
                                            children: "Java EE, .NET Framework, older Python codebases, or proprietary systems that are production-critical but no longer actively maintained and difficult to extend. The risk of leaving them untouched grows with each year — a framework migration or strangler-fig decomposition reduces operational risk without requiring a complete rewrite."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-lg font-bold text-gray-900 mb-2",
                                            children: "Businesses building custom enterprise tooling"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-gray-600 text-base leading-relaxed",
                                            children: "Organisations with processes genuinely too specific for any off-the-shelf ERP: a proprietary logistics coordination platform, a custom risk engine, a bespoke workflow connecting systems in a way no packaged product supports. Custom development is warranted when configuration would produce an unmaintainable product — and counterproductive when a standard ERP implementation would serve the same outcome."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-lg font-bold text-gray-900 mb-2",
                                            children: "Teams preparing for DPDP Act or RBI / SEBI data requirements"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "text-gray-600 text-base leading-relaxed",
                                            children: [
                                                "DPDP Act 2023 requires consent management and data principal rights workflows that most legacy CRMs and ERPs were not built to support. RBI data residency requirements for payment system operators and NBFCs create additional constraints on where data is stored and how it flows between systems. Modernisation engagements include compliance-aware architecture where applicable — and where regulatory exposure is the main driver, we begin with a",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    href: "/services/cybersecurity",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        className: "text-indigo-600 font-medium hover:text-indigo-800 transition-colors",
                                                        children: "cybersecurity risk assessment"
                                                    })
                                                }),
                                                "."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-14 bg-white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-6",
                            children: "Why Enterprise Systems Need to Modernise Before AI Can Deliver"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: "Most AI initiatives stall not because of the AI — but because the enterprise systems underneath don't expose data in a form agents can consume. Legacy ERPs, CRMs, and internal applications were not designed with external API access or real-time event streaming in mind."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-10",
                            children: "ITMTB modernises enterprise applications and ERP systems so the systems you've built over the last decade remain operational while new capabilities are layered on top — without the risk of a big-bang rewrite."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs font-semibold uppercase tracking-widest text-gray-400 mb-5",
                            children: "Typical enterprise application activities"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 mb-10",
                            children: activities.map(function(activity) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center gap-3 bg-gray-50 border border-gray-100 rounded-lg px-4 py-3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "w-1.5 h-1.5 rounded-full bg-indigo-400 flex-shrink-0"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-sm text-gray-700",
                                            children: activity
                                        })
                                    ]
                                }, activity);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed",
                            children: "Engagements cover discovery, API layer design, progressive migration, and post-delivery operations — helping enterprises extend the life of existing systems while making them ready for the next decade of tooling."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "engage",
                className: "px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-5xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-3",
                            children: "Engagement Methodology"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-600 text-base md:text-lg mb-10",
                            children: "Every engagement follows a defined sequence — no build commitment before the discovery sprint is complete."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-8",
                            children: engagementPhases.map(function(phase) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bg-white border border-gray-200 rounded-xl p-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-xs font-semibold uppercase tracking-widest text-indigo-500 mb-5",
                                            children: phase.period
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: "space-y-3",
                                            children: phase.items.map(function(item) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "flex items-start gap-2 text-sm text-gray-700",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "mt-1.5 w-1 h-1 rounded-full bg-gray-400 flex-shrink-0"
                                                        }),
                                                        item
                                                    ]
                                                }, item);
                                            })
                                        })
                                    ]
                                }, phase.period);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/itmtb-how-we-work",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "inline-flex items-center text-sm font-semibold text-indigo-600 hover:text-indigo-800 transition-colors",
                                children: "See the full engagement methodology →"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_trust_SuccessStoryEmbed__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                referTag: "Enterprise Applications and Automation",
                maxItems: 3,
                heading: "Selected work in enterprise applications"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-8 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "max-w-4xl text-sm text-gray-500 leading-relaxed",
                    children: [
                        "A regulated example of this pattern is our",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/blog/pharma-compliance-ai-sop-bmr-warning-letter-review",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "text-indigo-600 font-medium hover:text-indigo-800 transition-colors",
                                children: "pharma compliance AI platform"
                            })
                        }),
                        ", where enterprise identity, document workflow, auditability, and AI-assisted review had to work as one governed application."
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-14 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-6",
                            children: "Building the Integration Layer That AI Agents Need"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: "AI agents require access to live operational data — inventory levels, order status, customer records, financial positions. If your ERP or CRM doesn't expose this through a clean, versioned API, agents either operate on stale data or can't act at all."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: "The integration layer we build is not a workaround. It is a versioned, testable API over your existing data stores — with event streaming added where agents need to react to real-time state changes rather than polling. This layer outlasts any specific AI tooling you adopt."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed",
                            children: "Systems we have built integration layers for include SAP Business One, Microsoft Dynamics 365, Salesforce, Tally, proprietary Java EE applications, and legacy .NET systems — all without replacing the underlying system before the business is ready."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "comparison",
                className: "scroll-mt-24 px-8 md:px-[60px] py-14 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-6xl overflow-x-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-3",
                            children: "Strangler-Fig vs Big-Bang vs Lift-and-Shift: Which ERP Modernisation Approach Fits Your Risk Profile?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-600 text-base mb-8",
                            children: "The structural differences between a big-bang rewrite, a lift-and-shift, and a progressive strangler-fig migration — and why most enterprise modernisation engagements suit the strangler-fig approach."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                            className: "w-full border-collapse text-sm min-w-[640px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                        className: "border-b-2 border-gray-200",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                className: "text-left py-3 pr-6 w-[20%]"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                className: "text-left py-3 pr-6 text-gray-900 font-semibold w-[26%]",
                                                children: "Big-Bang Rewrite"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                className: "text-left py-3 pr-6 text-gray-900 font-semibold w-[27%]",
                                                children: "Lift-and-Shift"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("th", {
                                                className: "text-left py-4 pr-6 text-indigo-900 font-semibold w-[27%] bg-indigo-50 px-4",
                                                children: [
                                                    "Strangler-Fig Migration",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "font-normal text-xs text-indigo-400",
                                                        children: "ITMTB approach"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                                    children: comparisonRows.map(function(row, idx) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                            className: idx % 2 === 0 ? "bg-gray-50/40" : "bg-white",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    className: "py-4 pr-6 text-gray-500 font-medium text-xs uppercase tracking-wide align-top border-b border-gray-100",
                                                    children: row.label
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    className: "py-4 pr-6 text-gray-600 leading-snug align-top border-b border-gray-100",
                                                    children: row.col1
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    className: "py-4 pr-6 text-gray-600 leading-snug align-top border-b border-gray-100",
                                                    children: row.col2
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                    className: "py-4 pr-6 text-gray-800 leading-snug bg-indigo-50/60 px-4 align-top font-medium border-b border-indigo-100",
                                                    children: row.col3
                                                })
                                            ]
                                        }, row.label);
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "how-we-modernise",
                className: "scroll-mt-24 px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-5xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-3",
                            children: "How We Modernise Enterprise Systems"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-600 text-base md:text-lg mb-10",
                            children: "A structured four-phase process — scoped before any build commitment is made."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                            children: modernisationPhases.map(function(phase) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bg-white border border-gray-200 rounded-xl p-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex items-start gap-4 mb-5",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-3xl font-bold text-indigo-200 leading-none select-none",
                                                    children: phase.phase
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                            className: "text-base font-bold text-gray-900",
                                                            children: phase.title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-xs text-indigo-500 font-medium mt-1",
                                                            children: phase.duration
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: "space-y-2.5",
                                            children: phase.items.map(function(item) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "flex items-start gap-2 text-sm text-gray-700",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "mt-1.5 w-1 h-1 rounded-full bg-gray-400 flex-shrink-0"
                                                        }),
                                                        item
                                                    ]
                                                }, item);
                                            })
                                        })
                                    ]
                                }, phase.phase);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "engagement-model",
                className: "scroll-mt-24 px-8 md:px-[60px] py-14 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-gray-900 mb-6",
                            children: "Engagement Model"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: "Every engagement starts with a fixed-scope, fixed-price discovery sprint — typically two weeks. You leave with a written roadmap, risk register, cost estimate, and migration path recommendation before committing to a build."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-4",
                            children: "Build engagements are then scoped based on discovery findings and offered as fixed-scope, time-and-materials, or outcome-linked retainers — depending on the nature of the migration and your team's involvement. Post-launch, managed services engagements are available to maintain and evolve the systems we deliver."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-gray-700 text-base md:text-lg leading-relaxed mb-10",
                            children: "If the discovery sprint doesn't justify proceeding, you can stop there — with a written report that is useful regardless of whether you engage further."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bg-gray-50 border border-gray-200 rounded-xl p-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4",
                                            children: "What's included"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: "space-y-2.5",
                                            children: [
                                                "Discovery sprint: architecture review, API audit, risk register, cost estimate",
                                                "API layer design and development, tested and versioned",
                                                "Event streaming setup where real-time agent access is required",
                                                "Domain-by-domain migration with legacy system running throughout",
                                                "Architecture documentation, runbooks, and team handover",
                                                "4–8 week post-launch warranty period", 
                                            ].map(function(item) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "flex items-start gap-2 text-sm text-gray-700",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "mt-1.5 w-1.5 h-1.5 rounded-full bg-indigo-400 flex-shrink-0"
                                                        }),
                                                        item
                                                    ]
                                                }, item);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bg-gray-50 border border-gray-200 rounded-xl p-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4",
                                            children: "What's not included by default"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: "space-y-2.5",
                                            children: [
                                                "Business process redesign — we implement your process, not redesign it",
                                                "End-user training beyond technical handover",
                                                "Cloud infrastructure provisioning (handled via our cloud services engagement)",
                                                "Ongoing post-launch operations — this transitions to a managed services engagement",
                                                "ERP software licences (SAP, Microsoft Dynamics 365, Oracle — purchased separately)", 
                                            ].map(function(item) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    className: "flex items-start gap-2 text-sm text-gray-700",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "mt-1.5 w-1.5 h-1.5 rounded-full bg-gray-300 flex-shrink-0"
                                                        }),
                                                        item
                                                    ]
                                                }, item);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Capabilities2, {
                dataList: subServices,
                bg: "bg-[#402A6A]",
                insights: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(caseStudies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(insights)),
                hideFooter: true,
                hideCardSubtitle: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-5xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs font-semibold uppercase tracking-widest text-gray-400 mb-7",
                            children: "Related capabilities"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-3 gap-5",
                            children: [
                                {
                                    href: "/services/custom-software-development",
                                    label: "Custom Software Development",
                                    desc: "Our core engineering practice — greenfield platforms, customer-facing and operational systems, and AI-enabled products. Enterprise application modernisation sits beneath it."
                                },
                                {
                                    href: "/services/managed-services",
                                    label: "Managed IT Services",
                                    desc: "Operations management and production support for the systems we build or take over — yearly engagements with weekly reporting."
                                },
                                {
                                    href: "/services/cloud",
                                    label: "Cloud Infrastructure",
                                    desc: "Architecture, migration, and operations for the cloud layer your modernised applications run on."
                                },
                                {
                                    href: "/agentic-ai",
                                    label: "AI Agent Deployment",
                                    desc: "Deploying AI agent systems that connect to the enterprise integration layers we build."
                                },
                                {
                                    href: "/services/tech-stack-audit",
                                    label: "Tech Stack Audit",
                                    desc: "An independent review of an existing application, cloud, and data stack before you modernise or rebuild — risks, technical debt, and a prioritised roadmap."
                                }, 
                            ].map(function(link) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: link.href,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        className: "block bg-white border border-gray-200 rounded-xl p-6 hover:border-indigo-400 hover:shadow-sm transition-all group",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-base font-semibold text-gray-900 group-hover:text-indigo-600 transition-colors mb-2",
                                                children: link.label
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm text-gray-500 leading-relaxed",
                                                children: link.desc
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "mt-4 inline-block text-sm font-semibold text-indigo-500 group-hover:text-indigo-700 transition-colors",
                                                children: "Learn more →"
                                            })
                                        ]
                                    })
                                }, link.href);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "faq",
                className: "scroll-mt-24",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    items: faqItems
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceEngagementLinks__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-16 bg-[#0d0822]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-3xl mx-auto text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs font-semibold uppercase tracking-widest text-indigo-400 mb-5",
                            children: "Start the conversation"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl md:text-3xl font-bold text-white mb-5",
                            children: "Start with a Discovery Sprint"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-slate-300 text-base md:text-lg leading-relaxed mb-8",
                            children: "Two weeks, fixed price. We review your architecture, audit integration exposure, map dependencies, and deliver a written migration recommendation — before you commit to a build."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/contact-us?utm_source=service-enterprise-applications&utm_content=bottom-cta",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "inline-block bg-[#f1aa4e] text-black font-semibold text-base px-8 py-3.5 rounded-md hover:bg-[#e09a3e] transition-colors",
                                children: "Request a discovery sprint →"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {})
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,8657,2684,1831,9774,2888,179], function() { return __webpack_exec__(7722); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);